import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import FieldText from '@dex/bubl-dash/src/lib/components/Fields/FieldText';
import FieldPopup from '@dex/bubl-dash/src/lib/components/Fields/FieldPopup';
import FieldBlocks from './FieldBlocks';

const FieldBlocksSwitchTabs: React.FC<any> = (props: any) => {

    const { form, page, prefix } = props;

    return useMemo(() => (

        <FieldPopup
            buttonLabel={"Edit Tab " + (page.title ? ` - ${page.title}` : "")}
            heading={'Edit Tab'}
            form={form}
            name={prefix}
        >

            <Row gutter={8} edge={true}>

                <Col col={{ xs: 24, md: 24 }}>

                    <FieldText
                        form={form}
                        label={"Tab Title"}
                        name={`${prefix}.title`}
                        required={true}
                        defaultValue={page.title}
                    />

                </Col>

                <Col col={{ xs: 24, md: 24 }}>

                    <FieldBlocks
                        form={form}
                        name={`${prefix}.innerBlocks`}
                        defaultValue={page.innerBlocks}
                        disabled={["switchTabs", "pageContent", "accordion"]}
                    />

                </Col>

            </Row>

        </FieldPopup>

    ), [props]);

}

export default FieldBlocksSwitchTabs;
